 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT from '@/components/html/03_Copyright'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_SERIES_PAGE from '@/components/html/01_Series_Page'
 import HTML04_CONTENTS from '@/components/html/04_CONTENTS'
 import HTML05_FOREWORD from '@/components/html/05_Foreword'
 import HTML06_INTRODUCTION from '@/components/html/06_Introduction'
 import HTML07_HALFTITLE_PAGE from '@/components/html/07_Halftitle_Page'
 import HTML08_3_WOMEN from '@/components/html/08_3_Women'
 import HTML09_ACE_IN_THE_HOLE from '@/components/html/09_Ace_in_the_Hole'
 import HTML10_ADAPTATION from '@/components/html/10_Adaptation'
 import HTML11_AFTER_DARK__MY_SWEET from '@/components/html/11_After_Dark__My_Sweet'
 import HTML12_AFTER_HOURS from '@/components/html/12_After_Hours'
 import HTML13_THE_AGE_OF_INNOCENCE from '@/components/html/13_The_Age_of_Innocence'
 import HTML14_ARMY_OF_SHADOWS from '@/components/html/14_Army_of_Shadows'
 import HTML15_ATLANTIC_CITY from '@/components/html/15_Atlantic_City'
 import HTML16_AU_REVOIR_LES_ENFANTS from '@/components/html/16_Au_Revoir_les_Enfants'
 import HTML17_BABEL from '@/components/html/17_Babel'
 import HTML18_THE_BAND_WAGON from '@/components/html/18_The_Band_Wagon'
 import HTML19_BARAKA from '@/components/html/19_Baraka'
 import HTML20_THE_BATTLE_OF_ALGIERS from '@/components/html/20_The_Battle_of_Algiers'
 import HTML21_BERGMAN_S_TRILOGY_1__THROUGH_A_G from '@/components/html/21_Bergman_s_Trilogy_1__Through_a_G'
 import HTML22_BERGMAN_S_TRILOGY_2__WINTER_LIGH from '@/components/html/22_Bergman_s_Trilogy_2__Winter_Ligh'
 import HTML23_BERGMAN_S_TRILOGY_3__THE_SILENCE from '@/components/html/23_Bergman_s_Trilogy_3__The_Silence'
 import HTML24_THE_BEST_YEARS_OF_OUR_LIVES from '@/components/html/24_The_Best_Years_of_Our_Lives'
 import HTML25_THE_BIG_RED_ONE from '@/components/html/25_The_Big_Red_One'
 import HTML26_BLADE_RUNNER__THE_FINAL_CUT from '@/components/html/26_Blade_Runner__The_Final_Cut'
 import HTML27_CABIRIA from '@/components/html/27_Cabiria'
 import HTML28_CAT_PEOPLE from '@/components/html/28_Cat_People'
 import HTML29_CHIMES_AT_MIDNIGHT from '@/components/html/29_Chimes_at_Midnight'
 import HTML30_CHOP_SHOP from '@/components/html/30_Chop_Shop'
 import HTML31_CHUCK_JONES__THREE_CARTOONS from '@/components/html/31_Chuck_Jones__Three_Cartoons'
 import HTML32_COOL_HAND_LUKE from '@/components/html/32_Cool_Hand_Luke'
 import HTML33_CRIMES_AND_MISDEMEANORS from '@/components/html/33_Crimes_and_Misdemeanors'
 import HTML34_CRUMB from '@/components/html/34_Crumb'
 import HTML35_DARK_CITY from '@/components/html/35_Dark_City'
 import HTML36_THE_DEAD from '@/components/html/36_The_Dead'
 import HTML37_DIVA from '@/components/html/37_Diva'
 import HTML38_DOG_DAY_AFTERNOON from '@/components/html/38_Dog_Day_Afternoon'
 import HTML39_THE_DOUBLE_LIFE_OF_VERONIQUE from '@/components/html/39_The_Double_Life_of_Veronique'
 import HTML40_EASY_RIDER from '@/components/html/40_Easy_Rider'
 import HTML41_EL_NORTE from '@/components/html/41_El_Norte'
 import HTML42_EL_TOPO from '@/components/html/42_El_Topo'
 import HTML43_THE_ENIGMA_OF_KASPAR_HAUSER from '@/components/html/43_The_Enigma_of_Kaspar_Hauser'
 import HTML44_EXOTICA from '@/components/html/44_Exotica'
 import HTML45_FANNY_AND_ALEXANDER from '@/components/html/45_Fanny_and_Alexander'
 import HTML46_FAUST from '@/components/html/46_Faust'
 import HTML47_FITZCARRALDO from '@/components/html/47_Fitzcarraldo'
 import HTML48_FORBIDDEN_GAMES from '@/components/html/48_Forbidden_Games'
 import HTML49_THE_GODFATHER__PART_II from '@/components/html/49_The_Godfather__Part_II'
 import HTML50_THE_GREAT_DICTATOR from '@/components/html/50_The_Great_Dictator'
 import HTML51_GROUNDHOG_DAY from '@/components/html/51_Groundhog_Day'
 import HTML52_HOWARDS_END from '@/components/html/52_Howards_End'
 import HTML53_INHERIT_THE_WIND from '@/components/html/53_Inherit_the_Wind'
 import HTML54_JOHNNY_GUITAR from '@/components/html/54_Johnny_Guitar'
 import HTML55_JULIET_OF_THE_SPIRITS from '@/components/html/55_Juliet_of_the_Spirits'
 import HTML56_KILLER_OF_SHEEP from '@/components/html/56_Killer_of_Sheep'
 import HTML57_LA_BELLE_NOISEUSE from '@/components/html/57_La_Belle_Noiseuse'
 import HTML58_L_A__CONFIDENTIAL from '@/components/html/58_L_A__Confidential'
 import HTML59_THE_LAST_PICTURE_SHOW from '@/components/html/59_The_Last_Picture_Show'
 import HTML60_LAST_TANGO_IN_PARIS from '@/components/html/60_Last_Tango_in_Paris'
 import HTML61_THE_LAST_TEMPTATION_OF_CHRIST from '@/components/html/61_The_Last_Temptation_of_Christ'
 import HTML62_LATE_SPRING from '@/components/html/62_Late_Spring'
 import HTML63_LEOLO from '@/components/html/63_Leolo'
 import HTML64_THE_LONG_GOODBYE from '@/components/html/64_The_Long_Goodbye'
 import HTML65_MAGNOLIA from '@/components/html/65_Magnolia'
 import HTML66_THE_MARRIAGE_OF_MARIA_BRAUN from '@/components/html/66_The_Marriage_of_Maria_Braun'
 import HTML67_MEPHISTO from '@/components/html/67_Mephisto'
 import HTML68_MISHIMA__A_LIFE_IN_FOUR_CHAPTERS from '@/components/html/68_Mishima__A_Life_in_Four_Chapters'
 import HTML69_MON_ONCLE_ANTOINE from '@/components/html/69_Mon_Oncle_Antoine'
 import HTML70_MOOLAADE from '@/components/html/70_Moolaade'
 import HTML71_MY_FAIR_LADY from '@/components/html/71_My_Fair_Lady'
 import HTML72_MY_MAN_GODFREY from '@/components/html/72_My_Man_Godfrey'
 import HTML73_NANOOK_OF_THE_NORTH from '@/components/html/73_Nanook_of_the_North'
 import HTML74_ORDET from '@/components/html/74_Ordet'
 import HTML75_OUT_OF_THE_PAST from '@/components/html/75_Out_of_the_Past'
 import HTML76_PAN_S_LABYRINTH from '@/components/html/76_Pan_s_Labyrinth'
 import HTML77_PATHS_OF_GLORY from '@/components/html/77_Paths_of_Glory'
 import HTML78_THE_PHANTOM_OF_THE_OPERA from '@/components/html/78_The_Phantom_of_the_Opera'
 import HTML79_PIXOTE from '@/components/html/79_Pixote'
 import HTML80_PLAYTIME from '@/components/html/80_Playtime'
 import HTML81_A_PRAIRIE_HOME_COMPANION from '@/components/html/81_A_Prairie_Home_Companion'
 import HTML82_REBEL_WITHOUT_A_CAUSE from '@/components/html/82_Rebel_Without_a_Cause'
 import HTML83_THE_RED_SHOES from '@/components/html/83_The_Red_Shoes'
 import HTML84_RIPLEY_S_GAME from '@/components/html/84_Ripley_s_Game'
 import HTML85_THE_RIVER__LE_FLEUVE from '@/components/html/85_The_River__Le_Fleuve'
 import HTML86_ROCCO_AND_HIS_BROTHERS from '@/components/html/86_Rocco_and_His_Brothers'
 import HTML87_SAFETY_LAST from '@/components/html/87_Safety_Last'
 import HTML88_SAMURAI_REBELLION from '@/components/html/88_Samurai_Rebellion'
 import HTML89_SANSHO_THE_BAILIFF from '@/components/html/89_Sansho_the_Bailiff'
 import HTML90_SANTA_SANGRE from '@/components/html/90_Santa_Sangre'
 import HTML91_THE_SCARLET_EMPRESS from '@/components/html/91_The_Scarlet_Empress'
 import HTML92_SECRETS___LIES from '@/components/html/92_Secrets___Lies'
 import HTML93_THE_SHINING from '@/components/html/93_The_Shining'
 import HTML94_THE_TERRORIST from '@/components/html/94_The_Terrorist'
 import HTML95_THE_THIEF_OF_BAGDAD from '@/components/html/95_The_Thief_of_Bagdad'
 import HTML96_TOP_HAT from '@/components/html/96_Top_Hat'
 import HTML97_TRIUMPH_OF_THE_WILL from '@/components/html/97_Triumph_of_the_Will'
 import HTML98_VENGEANCE_IS_MINE from '@/components/html/98_Vengeance_Is_Mine'
 import HTML99_WAKING_LIFE from '@/components/html/99_Waking_Life'
 import HTML100_WERCKMEISTER_HARMONIES from '@/components/html/100_Werckmeister_Harmonies'
 import HTML101_WHAT_EVER_HAPPENED_TO_BABY_JANE from '@/components/html/101_What_Ever_Happened_to_Baby_Jane'
 import HTML102_WITHNAIL___I from '@/components/html/102_Withnail___I'
 import HTML103_A_WOMAN_S_TALE from '@/components/html/103_A_Woman_s_Tale'
 import HTML104_WOODSTOCK from '@/components/html/104_Woodstock'
 import HTML105_WR_MYSTERIES_OF_THE_ORGANISM from '@/components/html/105_WR_Mysteries_of_the_Organism'
 import HTML106_A_YEAR_OF_THE_QUIET_SUN from '@/components/html/106_A_Year_of_the_Quiet_Sun'
 import HTML107_YOJIMBO from '@/components/html/107_Yojimbo'
 import HTML108_ESSAYS_APPEARING_IN_THE_GREAT_MO from '@/components/html/108_ESSAYS_APPEARING_IN_THE_GREAT_MO'
 import HTML109_ESSAYS_APPEARING_IN_THE_GREAT_MO from '@/components/html/109_ESSAYS_APPEARING_IN_THE_GREAT_MO'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_CONTENTS",
 			"name" : "html/04_CONTENTS",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Foreword",
 			"name" : "html/05_Foreword",
 			"component" : HTML05_FOREWORD
 		},
 		{
 			"path" : "/html/06_Introduction",
 			"name" : "html/06_Introduction",
 			"component" : HTML06_INTRODUCTION
 		},
 		{
 			"path" : "/html/07_Halftitle_Page",
 			"name" : "html/07_Halftitle_Page",
 			"component" : HTML07_HALFTITLE_PAGE
 		},
 		{
 			"path" : "/html/08_3_Women",
 			"name" : "html/08_3_Women",
 			"component" : HTML08_3_WOMEN
 		},
 		{
 			"path" : "/html/09_Ace_in_the_Hole",
 			"name" : "html/09_Ace_in_the_Hole",
 			"component" : HTML09_ACE_IN_THE_HOLE
 		},
 		{
 			"path" : "/html/10_Adaptation",
 			"name" : "html/10_Adaptation",
 			"component" : HTML10_ADAPTATION
 		},
 		{
 			"path" : "/html/11_After_Dark__My_Sweet",
 			"name" : "html/11_After_Dark__My_Sweet",
 			"component" : HTML11_AFTER_DARK__MY_SWEET
 		},
 		{
 			"path" : "/html/12_After_Hours",
 			"name" : "html/12_After_Hours",
 			"component" : HTML12_AFTER_HOURS
 		},
 		{
 			"path" : "/html/13_The_Age_of_Innocence",
 			"name" : "html/13_The_Age_of_Innocence",
 			"component" : HTML13_THE_AGE_OF_INNOCENCE
 		},
 		{
 			"path" : "/html/14_Army_of_Shadows",
 			"name" : "html/14_Army_of_Shadows",
 			"component" : HTML14_ARMY_OF_SHADOWS
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js